/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { WirelessHealthStatus } from "../../models/wireless-health-status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetWirelessHealthStatus$Params {
  subscription_id: string;
  count_num_access_points?: boolean;
}

export function getWirelessHealthStatus(
  http: HttpClient,
  rootUrl: string,
  params: GetWirelessHealthStatus$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<WirelessHealthStatus>> {
  const rb = new RequestBuilder(rootUrl, getWirelessHealthStatus.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
    rb.query("count_num_access_points", params.count_num_access_points, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WirelessHealthStatus>;
    }),
  );
}

getWirelessHealthStatus.PATH = "/dashboard/health/wireless/{subscription_id}";
